import styles from "./styles/CourseCheckout.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Form, Row, Col, Button, Accordion, Spinner } from "react-bootstrap";
import { InputField, SelectField } from "@components";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { addOrderAction } from "@redux/actions";
import { listCountries, listMonths } from "./listCountry";
import moment from "moment";
import { getDiscountValid } from "@helpers";
// import Select from "react-select";

const cardNumRegExp = /^\d+$/;
// const phoneRegExp =
//   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const validateSchema = Yup.object().shape({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  country: Yup.string().required("Country is required"),
  address: Yup.string().required("Address is required"),
  phoneNumber: Yup.string()
    .required("Phone Number is required")
    // .matches(phoneRegExp, "Phone Number is not valid"),
    .matches(
      cardNumRegExp,
      "Phone Number is not valid. Please follow this sample: 853741245"
    )
    .min(
      4,
      "Phone Number must be have at least 4 digits and follow this sample: 853741245"
    )
    .max(
      12,
      "Phone Number must be less than 12 digits and follow this sample: 853741245"
    ),
  // fullName: Yup.string().when().required("Full Name is required"),
  // cardNumber: Yup.string()
  //   .required("Card Number is required")
  //   .matches(cardNumRegExp, "Card Number is not valid")
  //   .min(16, "Card Number must be have 16 digits")
  //   .max(16, "Card Number must be have 16 digits"),
  // year: Yup.date()
  //   .required("Year is required")
  //   .min(
  //     moment().year(),
  //     "Year must be current year or greater than current year"
  //   ),
  // month: Yup.date()
  //   .required("Month is required")
  //   .when("year", (year) => {
  //     if (moment(year).year() === moment().year() && year) {
  //       return Yup.date()
  //         .min(
  //           moment().month() + 1,
  //           "Month must be current month or greater than current month"
  //         )
  //         .required("Month is required")
  //         .typeError("Month is required");
  //     }
  //   }),
  // cvc: Yup.string()
  //   .required("CVC is required")
  //   .matches(cardNumRegExp, "CVC is not valid")
  //   .min(3, "CVC must be have 3 characters")
  //   .max(3, "CVC must be have 3 characters"),
  fullName: Yup.string().when("paymentType", (paymentType) => {
    if (paymentType === 1) {
      return Yup.string().required("Full Name is required");
    }
  }),
  cardNumber: Yup.string().when("paymentType", (paymentType) => {
    if (paymentType === 1) {
      return Yup.string()
        .required("Card Number is required")
        .matches(cardNumRegExp, "Card Number is not valid")
        .min(16, "Card Number must be have 16 digits")
        .max(16, "Card Number must be have 16 digits");
    }
  }),
  year: Yup.date().when("paymentType", (paymentType) => {
    if (paymentType === 1) {
      return Yup.date()
        .required("Year is required")
        .min(
          moment().year(),
          "Year must be current year or greater than current year"
        );
    }
  }),
  month: Yup.date().when("paymentType", (paymentType) => {
    if (paymentType === 1) {
      return Yup.date()
        .required("Month is required")
        .when("year", (year) => {
          if (moment(year).year() === moment().year() && year) {
            return Yup.date()
              .min(
                moment().month() + 1,
                "Month must be current month or greater than current month"
              )
              .required("Month is required")
              .typeError("Month is required");
          }
        });
    }
  }),
  cvc: Yup.string().when("paymentType", (paymentType) => {
    if (paymentType === 1) {
      return Yup.string()
        .required("CVC is required")
        .matches(cardNumRegExp, "CVC is not valid")
        .min(3, "CVC must be have 3 characters")
        .max(3, "CVC must be have 3 characters");
    }
  }),
});

const initialValues = {
  firstName: "",
  lastName: "",
  country: "",
  address: "",
  phoneNumber: "",
  fullName: "",
  cardNumber: "",
  month: "",
  year: "",
  cvc: "",
  paymentType: 1,
};

const CourseCheckout = () => {
  // const [typeSubmit, setTypeSubmit] = useState(1);
  // const [tab, setTab] = useState("card");
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { addOrder } = useSelector((state) => state.orders);
  const { profile } = useSelector((state) => state.user);

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: validateSchema,
    onSubmit: async (values) => {
      // console.log({
      //   firstName: values.firstName,
      //   lastName: values.lastName,
      //   country: values.country,
      //   address: values.address,
      //   phoneNumber:
      //     `+${
      //       listCountries.filter((value) => {
      //         return values.country === value.id;
      //       })[0].phonePrefix
      //     }` + values.phoneNumber,
      //   courseIds: location.state.courses.map((value) => {
      //     return value.course.id;
      //   }),
      //   // courseIds: location.state.courseIds,
      //   payment: {
      //     fullName: values.fullName || "string",
      //     cardNumber: values.cardNumber || "string",
      //     month: values.month || 0,
      //     year: values.year || 0,
      //     cvc: values.cvc || "string",
      //   },
      //   paymentType: values.paymentType,
      // });
      await dispatch(
        addOrderAction({
          data: {
            firstName: values.firstName,
            lastName: values.lastName,
            country: values.country,
            address: values.address,
            phoneNumber:
              `+${
                listCountries.filter((value) => {
                  return values.country === value.id;
                })[0].phonePrefix
              }` + values.phoneNumber,
            courseIds: location.state.courses.map((value) => {
              return value.course.id;
            }),
            // courseIds: location.state.courseIds,
            payment: {
              fullName: values.fullName || "string",
              cardNumber: values.cardNumber || "string",
              month: values.month || 0,
              year: values.year || 0,
              cvc: values.cvc || "string",
            },
            paymentType: values.paymentType,
          },
          navigate: () => {
            navigate("/thank-you");
          },
        })
      );
    },
  });

  // const checkDiscountValid = (discounts) => {
  //   let totalPercent = 0;
  //   discounts.map((value) => {
  //     if (
  //       moment().format("DD/MM/YYYY") >=
  //         moment(value.startDate).format("DD/MM/YYYY") &&
  //       moment().format("DD/MM/YYYY") <=
  //         moment(value.endDate).format("DD/MM/YYYY")
  //     ) {
  //       totalPercent += value.discountPercent;
  //     }
  //   });
  //   return totalPercent / 100;
  // };

  const BillingDetails = () => {
    return (
      <>
        <Row className={clsx(styles.rowContainer)}>
          <Col>
            <Form.Group className="px-0 mb-3" controlId="firstName">
              <Form.Label>First Name*</Form.Label>
              <InputField
                name={"firstName"}
                type={"text"}
                placeholder="First name"
                value={values.firstName}
                onChange={handleChange}
                onBlur={handleBlur}
                autoComplete="off"
                touchedValue={touched.firstName}
                errorsValue={errors.firstName}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="px-0 mb-3" controlId="lastName">
              <Form.Label>Last Name*</Form.Label>
              <InputField
                name={"lastName"}
                type={"text"}
                placeholder="Last name"
                value={values.lastName}
                onChange={handleChange}
                onBlur={handleBlur}
                autoComplete="off"
                touchedValue={touched.lastName}
                errorsValue={errors.lastName}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group className="px-0 mb-3" controlId="country">
              <Form.Label>Country*</Form.Label>

              <SelectField
                name={"country"}
                value={values.country || ""}
                onChange={(val) => setFieldValue("country", val)}
                listValue={listCountries}
                isLoading={false}
                placeholder={"Country"}
                error={errors.country}
                setFieldError={() =>
                  setFieldError("country", "Country is required")
                }
                touched={touched.country}
                setFieldTouched={() => {
                  setFieldTouched("country", true);
                }}
                multiple={false}
                bold={false}
                prefixItem={true}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group className="px-0 mb-3" controlId="address">
              <Form.Label>Address*</Form.Label>
              <InputField
                name={"address"}
                type={"text"}
                placeholder="Address"
                value={values.address}
                onChange={handleChange}
                onBlur={handleBlur}
                autoComplete="off"
                touchedValue={touched.address}
                errorsValue={errors.address}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group className="px-0 mb-3" controlId="phoneNumber">
              <Form.Label>Phone Number*</Form.Label>
              <InputField
                name={"phoneNumber"}
                type={"text"}
                placeholder="Phone Number"
                value={values.phoneNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                autoComplete="off"
                touchedValue={touched.phoneNumber}
                errorsValue={errors.phoneNumber}
                prefix={
                  <span>
                    {values.country
                      ? `+${
                          listCountries.filter((value) => {
                            return values.country === value.id;
                          })[0].phonePrefix
                        }`
                      : ""}
                  </span>
                }
              />
            </Form.Group>
          </Col>
        </Row>
      </>
    );
  };

  const OrderSummary = () => {
    return (
      <div className={styles.orderSummary}>
        <h5>Order Summary</h5>
        <div
          style={{ borderBottom: "1px solid #efefef", margin: "30px 0" }}
          className="d-flex flex-column"
        >
          {location.state.courses.map((value) => {
            return (
              <div
                key={`course ${value.course.id}`}
                className="d-flex justify-content-between"
                style={{ gap: "10px" }}
              >
                <h6 style={{ fontWeight: "bolder", flexBasis: "80%" }}>
                  {value.course.title}
                </h6>
                <h6 style={{ color: "#686F7A", flexBasis: "20%" }}>{`$${(
                  value.course.price -
                  value.course.price * getDiscountValid(value.course.discounts)
                ).toFixed(2)}`}</h6>
              </div>
            );
          })}
        </div>
        <div
          style={{ borderBottom: "1px solid #efefef", margin: "30px 0" }}
          className="d-flex justify-content-between"
        >
          <h6 style={{ fontSize: 20 }}>Total</h6>
          <h6 style={{ fontSize: 20 }}>{`$${location.state.courses
            .map((value) => {
              return (
                value.course.price -
                (
                  value.course.price * getDiscountValid(value.course.discounts)
                ).toFixed(2)
              );
            })
            .reduce((result, number) => {
              return result + number;
            })
            .toFixed(2)}`}</h6>
        </div>
        <div
          style={{ fontSize: 14, color: "#686f7a" }}
          className="d-flex justify-content-center align-items-center"
        >
          <i className="fa-solid fa-lock ml-1"></i>
          <div style={{ margin: "0 5px" }}></div>
          <p className="mb-0 mr-1">Secure Checkout</p>
        </div>
      </div>
    );
  };

  const total = Number(
    location.state.courses
      .map((value) => {
        return (
          value.course.price -
          (
            value.course.price * getDiscountValid(value.course.discounts)
          ).toFixed(2)
        );
      })
      .reduce((result, number) => {
        return result + number;
      })
      .toFixed(2)
  );

  const TabCheckout = () => {
    switch (values.paymentType) {
      case 1:
        return (
          <>
            <Row>
              <Col>
                <Form.Group className="px-0 mb-3" controlId="fullName">
                  <Form.Label>Full Name*</Form.Label>
                  <InputField
                    name={"fullName"}
                    type={"text"}
                    placeholder="Enter Your Full Name"
                    value={values.fullName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    touchedValue={touched.fullName}
                    errorsValue={errors.fullName}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="px-0 mb-3" controlId="cardNumber">
                  <Form.Label>Card Number*</Form.Label>
                  <InputField
                    name={"cardNumber"}
                    type={"text"}
                    placeholder="Enter Card Number"
                    value={values.cardNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    touchedValue={touched.cardNumber}
                    errorsValue={errors.cardNumber}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="px-0 mb-3" controlId="month">
                  <Form.Label>Month*</Form.Label>
                  <SelectField
                    name={"month"}
                    value={values.month || ""}
                    onChange={(val) => setFieldValue("month", val)}
                    listValue={listMonths}
                    isLoading={false}
                    placeholder={"Month"}
                    error={errors.month}
                    setFieldError={() =>
                      setFieldError("month", "Month is required")
                    }
                    touched={touched.month}
                    setFieldTouched={() => {
                      setFieldTouched("month", true);
                    }}
                    multiple={false}
                    bold={false}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="px-0 mb-3" controlId="year">
                  <Form.Label>Year*</Form.Label>
                  <InputField
                    name={"year"}
                    type={"text"}
                    placeholder="Year"
                    value={values.year}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    touchedValue={touched.year}
                    errorsValue={errors.year}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="px-0 mb-3" controlId="cvc">
                  <Form.Label>CVC*</Form.Label>
                  <InputField
                    name={"cvc"}
                    type={"text"}
                    placeholder="CVC"
                    value={values.cvc}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    touchedValue={touched.cvc}
                    errorsValue={errors.cvc}
                  />
                </Form.Group>
              </Col>
            </Row>
          </>
        );
      case 0:
        console.log(Number(profile.data.balance) < total);
        return (
          <div className={clsx(styles.balanceContainer)}>
            <div className={clsx(styles.balanceCurrent)}>
              <span>Your Balance:</span>
              <span className={clsx(styles.balancePrice)}>
                {profile.data.balance}$
              </span>
            </div>
            <div className={clsx(styles.balanceCurrent)}>
              {Number(profile.data.balance) < total ? (
                <span>Your Balance Is Not Enoughed</span>
              ) : (
                <>
                  <span>Balance After Purchased:</span>
                  <span className={clsx(styles.balancePrice)}>
                    {(Number(profile.data.balance) - total).toFixed(2)}$
                  </span>
                </>
              )}
            </div>
          </div>
        );
      default:
        return (
          <div>
            <p style={{ fontStyle: 14, color: "#686F7A" }}>
              After Payment via Paypal secure checkout, we will send you a link
              download your file
            </p>
            <div className="d-flex">
              <p style={{ fontStyle: 14, color: "#686F7A" }}>Paypal accepts</p>
              <ul className={styles.listCard}>
                <li>
                  <img
                    alt="Visa"
                    title="Visa"
                    src="https://gambolthemes.net/html-items/cursus_main_demo/images/membership/pyicon-1.svg"
                  />
                </li>
                <li>
                  <img
                    alt="MasterCard"
                    title="MasterCard"
                    src="https://gambolthemes.net/html-items/cursus_main_demo/images/membership/pyicon-2.svg"
                  />
                </li>
                <li>
                  <img
                    alt="American Express"
                    title="American Express"
                    src="https://gambolthemes.net/html-items/cursus_main_demo/images/membership/pyicon-3.svg"
                  />
                </li>
                <li>
                  <img
                    alt="Discover"
                    title="Discover"
                    src="https://gambolthemes.net/html-items/cursus_main_demo/images/membership/pyicon-4.svg"
                  />
                </li>
                <li>
                  <img
                    alt="China UnionPay"
                    title="China UnionPay"
                    src="https://gambolthemes.net/html-items/cursus_main_demo/images/membership/pyicon-5.svg"
                  />
                </li>
              </ul>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="container">
      <div className={`${styles.mainWrapper} row m-0`}>
        <div className={`col-xl-8 col-lg-12 ${styles.wrapperBill}`}>
          <Form
            noValidate
            onSubmit={handleSubmit}
            className={styles.formContainer}
          >
            <div className={styles.billDetail}>
              <h5>Billing Details</h5>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Edit Address</Accordion.Header>
                  <Accordion.Body>{BillingDetails()}</Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
            <div className={styles.paymentMethod}>
              <h5>Select Payment Method</h5>
              <ul className={styles.wrapperMethod}>
                <li
                  className={clsx("w-100", {
                    [styles.active]: values.paymentType === 1,
                  })}
                  onClick={() => {
                    // setTab("card");
                    // setTypeSubmit(1);
                    setFieldValue("paymentType", 1);
                  }}
                >
                  <span>
                    <i className="bi bi-credit-card-2-back mr-2" />
                    Credit/Debit Card
                  </span>
                </li>
                <li
                  className={clsx("w-100", {
                    [styles.active]: values.paymentType === 0,
                  })}
                  onClick={() => {
                    // setTab("balance");
                    // setTypeSubmit(0);
                    // onChange={(val) => setFieldValue("month", val)}
                    setFieldValue("paymentType", 0);
                  }}
                >
                  <span>
                    <i className="bi bi-wallet2 mr-2" />
                    Balance
                  </span>
                </li>
                {/* 
                <li
                  className={clsx("w-100", { [styles.active]: tab === "paypal" })}
                  onClick={() => {
                    setTab("paypal");
                  }}
                >
                  <span>
                    <i className="bi bi-paypal mr-2" />
                    Paypal
                  </span>
                </li> */}
              </ul>
              {TabCheckout()}
            </div>
            <Col sm={12} className={clsx(styles.btnContainer)}>
              <Button
                type="submit"
                className={styles.btnSave}
                disabled={
                  addOrder.processing ||
                  (values.paymentType === 0 &&
                    Number(profile.data.balance) < total)
                }
              >
                <div className={clsx(styles.btnContent)}>
                  {addOrder.processing ? (
                    <Spinner
                      animation="border"
                      role="status"
                      className="text-center"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  ) : null}
                  <span>Confirm Checkout</span>
                </div>
              </Button>
            </Col>
          </Form>
        </div>

        <div
          style={{ position: "relative" }}
          className={`${styles.wrapperSummary} col-xl-4 col-lg-12 `}
        >
          <div style={{ position: "sticky", top: "90px" }}>
            {OrderSummary()}
          </div>
        </div>
      </div>
    </div>
  );
};

export { CourseCheckout };
